<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <router-link tag="button" :to="{name: 'proposals.create'}" class="btn btn-info">
          <span class="btn-label">
            <i class="material-icons">add</i>
          </span>
          Novo
        </router-link>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-md-12">
        <b-form @submit="onSubmit" @reset="onReset" novalidate="novalidate">
          <div class="card">
            <div class="card-header card-header-icon card-header-rose">
              <div class="card-icon" v-b-toggle.filter>
                <i class="material-icons">search</i>
              </div>
              <h4 class="card-title">Filtros</h4>
            </div>
            <br />
            <b-collapse id="filter">

              <div class="card-body">
                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group bmd-form-group is-filled">
                      <label for="date_filter" class="bmd-label-floating">Filtro Data</label>
                      <model-list-select
                        class="form-control"
                        :list="dateFilters"
                        option-value="id"
                        option-text="label"
                        v-model="form.date_filter"
                      ></model-list-select>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group bmd-form-group is-filled">
                      <label for="interval" class="bmd-label-floating">Intervalo Data</label>
                      <date-picker
                        range
                        v-model="form.interval"
                        lang="pt-br"
                        format="DD/MM/YYYY"
                        placeholder="Escolha uma data"
                        :not-after="form.end_at"
                      ></date-picker>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group bmd-form-group is-filled">
                      <label for="salesmans" class="bmd-label-floating">Vendedor</label>
                      <model-list-select
                        class="form-control"
                        :list="salesmans"
                        option-value="id"
                        option-text="name"
                        v-model="form.salesman_id"
                      ></model-list-select>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group bmd-form-group is-filled">
                      <label for="proposal_status" class="bmd-label-floating">Status da Proposta</label>
                      <model-list-select
                        class="form-control"
                        :list="proposalStatus"
                        option-value="id"
                        option-text="name"
                        v-model="form.proposal_status_id"
                      ></model-list-select>
                    </div>
                  </div>

                </div>

                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group bmd-form-group is-filled">
                      <label for="administrator_id" class="bmd-label-floating">Administradora</label>
                      <model-list-select
                        class="form-control"
                        :list="administrators"
                        option-value="id"
                        option-text="name"
                        v-model="form.administrator_id"
                        @input="loadGroups"
                      ></model-list-select>
                    </div>
                  </div>


                  <div class="col-md-4">
                    <div class="form-group bmd-form-group is-filled">
                      <label for="group_id" class="bmd-label-floating">Grupo</label>
                      <model-list-select
                        class="form-control"
                        :list="groups"
                        option-value="id"
                        option-text="name"
                        v-model="form.group_id"
                      ></model-list-select>
                    </div>
                  </div>
                   <div class="col-md-4">
                    <div
                      class="form-group bmd-form-group"
                      v-bind:class="{'is-filled': form.quota != ''}"
                    >
                      <label form="quota" class="bmd-label-floating">Cota</label>
                      <input
                        refs="quota"
                        type="text"
                        v-numeric-only
                        class="form-control"
                        v-model="form.quota"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">


                  <div class="col-md-4">
                    <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.physical_proposal != ''}">
                      <label form="physical_proposal" class="bmd-label-floating">Número do Contrato</label>
                      <input refs="physical_proposal" type="text" maxlength="20" v-numeric-only class="form-control" v-model="form.physical_proposal" />
                    </div>
                  </div>
                  <div class="col-md-8">
                    <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client_name != ''}">
                      <label form="client_name" class="bmd-label-floating">Nome / Parte do nome do <b>cliente</b></label>
                      <input refs="client_name" type="text" maxlength="64" class="form-control" v-model="form.client_name" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <button type="reset" class="btn btn-fill btn-outline-danger">Limpar</button>
                <button type="submit" class="btn btn-fill btn-rose">Filtrar</button>
              </div>
            </b-collapse>
          </div>
        </b-form>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-icon card-header-rose">
            <div class="card-icon">
              <i class="material-icons">list</i>
            </div>
            <h4 class="card-title">
              Lista
            </h4>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Grupo / Cota</th>
                    <th width="100px">Cliente</th>
                    <th>Bem</th>
                    <th>Carta</th>
                    <th>Parcela</th>
                    <th>Status</th>
                    <th>Vendedor</th>
                    <th>Data</th>
                    <th>Contrato</th>
                    <th class="text-right">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-show="proposals.length > 0"
                    v-for="iterator in proposals"
                    :key="iterator.id"
                  >
                    <td>
                      <center>{{ iterator.group ? iterator.group.name : '-' }} / {{ iterator.quota }}</center>
                    </td>
                    <td>{{ iterator.client.name }}</td>
                    <td>{{ iterator.model.manufacturer.name }} - {{ iterator.model.name }}</td>
                    <td>{{ iterator.value | price }}</td>
                    <td>{{ iterator.number_installments }}</td>
                    <td>{{ iterator.proposal_status.name }}</td>
                    <td>{{ iterator.salesman.name }}</td>
                    <td>{{ iterator.sale_at | moment('DD/MM/YYYY') }}</td>
                    <td>{{ iterator.physical_proposal }}</td>
                    <td class="td-actions text-right">
                      <b-button-group>
                        <router-link
                          data-original-title
                          title="Auditar"
                          class="btn btn-outline-primary btn-link"
                          tag="button"
                          :to="{name: 'audits.index', query: { page: 1, functionality: 12, register: iterator.id}}"
                        >
                          <i class="material-icons">find_in_page</i>
                        </router-link>
                        <router-link
                          data-original-title
                          title="Visualizar Proposta"
                          class="btn btn-outline-warning btn-link"
                          tag="button"
                          :to="{'name': 'proposals.show', params: { 'id' : iterator.id }}"
                        >
                          <i class="material-icons">search</i>
                        </router-link>
                        <router-link
                          data-original-title
                          title="Editar Proposta"
                          class="btn btn-block btn-sm btn-outline-success"
                          tag="button"
                          :to="{'name': 'proposals.edit', params: { 'id' : iterator.id }}"
                        >
                          <i class="material-icons">edit</i>
                        </router-link>
                        <b-button
                          title="Excluir"
                          class="btn btn-danger btn-link"
                          v-on:click="remove(iterator.id)"
                        >
                          <i class="material-icons">close</i>
                        </b-button>
                      </b-button-group>
                    </td>
                  </tr>
                  <tr v-show="proposals.length==0">
                    <td colspan="10">Nenhuma proposta encontrada!</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="card-footer" v-show="proposals.length">
            <div class="row" style="width:100%;">
                <div class="col-sm-4">
                      <model-list-select
                        class="form-control"
                        :list="limits"
                        option-value="limit"
                        option-text="text"
                        v-model="limit"
                        @input="onSubmit($event)"
                      ></model-list-select>
                </div>
                <div class="col-sm-4 text-center">
                    <b-pagination
                      order="is-right"
                      v-show="proposals.length > 0"
                      v-model="currentPage"
                      :simple="false"
                      :per-page="limit"
                      :total-rows="total"
                      @change="pageChange"
                    ></b-pagination>
                </div>
                <div class="col-sm-4 text-right text-secondary">
                    {{ to }} registros de {{ total }}
                </div>
              </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import GroupService from "@/services/modules/groups.service";
import JwtService from "@/services/jwt.service";
import ProposalService from "@/services/modules/proposals.service";
import UserService from "@/services/modules/users.service";

import Vue from "vue";

export default {
  computed: {
    administrators: {
      set(_administrators) {},
      get() {
        return this.$store.state.administrators.itens;
      }
    },
    proposals: {
      set(_proposals) {},
      get() {
        return this.$store.state.proposals.itens;
      }
    },
    proposalStatus: {
      set(_proposalStatus) {},
      get() {
        return this.$store.state.defaults.proposal_status;
      }
    }
  },
  created: function() {
    var self = this;

    self.initQueryString();

    if (self.proposalStatus.length === 0) {
      self.getDataProposalStatus();
    } else {
      if (self.administrators.length === 0) {
        self.getDataAdministrators();
      } else {
        self.getDataSalesmans();
      }
    }

    self.$root.$on("changeBranch", self.getData);
  },
  data() {
    return {
      currentPage: 1,
      form: {
        branch_id: "",
        date_filter: 'sale_at',
        interval: [Vue.moment().subtract(30, "days"), Vue.moment()],
        proposal_status_id: "",
        administrator_id: "",
        salesman_id: "",
        group_id: "",
        quota: "",
        physical_proposal: "",
        client_name : ""
      },
      groups: [],
      hideFilter: false,
      limit: null,
      limits : [
        { limit : 5, text : 'Exibir 5(cinco) por página' },
        { limit : 10, text : 'Exibir 10(dez) por página' },
        { limit : 25, text : 'Exibir 25(vinte e cinco) por página' },
        { limit : 50, text : 'Exibir 50(cinquenta) por página' },
      ],
      listProposals: [],
      salesmans: [],
      total: 0,
      to : 0,
      dateFilters: [{
        'id': 'sale_at',
        'label': 'Data da Venda',
      },{
        'id': 'deployment_at',
        'label': 'Data Alocação',
      },{
        'id': 'cancel_at',
        'label': 'Data de Cancelamento',
      }],
    };
  },
  methods: {
    async getData() {
      var self = this;

      self.$root.$emit("onLoading");

      self.form.branch_id = self.$store.state.auth.user.branch_id;

      setTimeout(function(){
        const response = self.$store.dispatch("proposals/all", {
          limit: self.limit,
          currentPage: self.currentPage,
          params: self.form
        });

        response.then(function(_pagination) {
          self.total = _pagination.total;
          self.to = _pagination.to;
          self.$root.$emit("onLoading");
        });

        response.catch(function() {
          self.$root.$emit("onLoading");
          self.$notify.error("Falha na comunicação com a API!");
        });
      }, 200);
    },
    async getDataAdministrators() {
      var self = this;

      self.$root.$emit("onLoading");

      const response = self.$store.dispatch("administrators/all");

      response.then(function() {
        self.getDataSalesmans();
        self.$root.$emit("onLoading");
      });

      response.catch(function() {
        self.getDataSalesmans();
        self.$root.$emit("onLoading");
      });
    },
    async getDataGroups(_administratorId) {
      var self = this;

      self.$root.$emit("onLoading");

      const response = GroupService.getByAdministratorId(_administratorId);

      response.then(function(_groups) {
        self.groups = _groups;
        self.$root.$emit("onLoading");
      });

      response.catch(function() {
        self.$root.$emit("onLoading");
      });
    },
    async getDataProposalStatus() {
      var self = this;

      self.$root.$emit("onLoading");

      const response = self.$store.dispatch("defaults/proposalStatus");

      response.then(function() {
        self.$root.$emit("onLoading");
        self.getDataAdministrators();
      });

      response.catch(function() {
        self.$root.$emit("onLoading");
        self.getDataAdministrators();
      });
    },
    async getDataSalesmans(_teamId) {
      var self = this;

      self.$root.$emit("onLoading");

      var params =
        "branch_id=" +
        JwtService.getBranchId() +
        "&profile_id=" +
        UserService.typeProfiles.salesman;

      const response = UserService.getByProfilesId(params);

      response.then(function(_users) {
        self.salesmans = _users;
        self.$root.$emit("onLoading");

        self.getData();
      });

      response.catch(function() {
        self.$root.$emit("onLoading");

        self.getData();
      });
    },
    hideFilters() {
      var self = this;

      self.hideFilter = !self.hideFilter;
    },
    initQueryString() {
        var self = this;
        var query = self.$route.query;

        self.limit = 5;

        if (query.limit) {
            self.limit = parseInt(query.limit);
        }
        if (query.currentPage) {
            setTimeout(function(){
                self.pageChange(parseInt(query.currentPage));
            }, 900);
        }
        if (query.interval && query.interval.length == 2) {
            self.form.interval = [
                Vue.moment(query.interval[0]),
                Vue.moment(query.interval[1])
            ];
        }
        if (query.date_filter) {
          self.form.date_filter = query.date_filter;
        }
        if (query.proposal_status_id) {
            self.form.proposal_status_id = parseInt(query.proposal_status_id);
        }
        if (query.administrator_id) {
            self.form.administrator_id = parseInt(query.administrator_id);
            self.loadGroups();
        }
        if (query.salesman_id) {
            self.form.salesman_id = parseInt(query.salesman_id);
        }
        if (query.group_id) {
            self.form.group_id = parseInt(query.group_id);
        }
        if (query.quota) {
            self.form.quota = parseInt(query.quota);
        }
        if (query.physical_proposal) {
            self.form.physical_proposal = query.physical_proposal;
        }
        if (query.client_name) {
            self.form.client_name = query.client_name;
        }
    },
    loadGroups() {
      if (this.form.administrator_id != "") {
        this.getDataGroups(this.form.administrator_id);
      }
    },
    pageChange(_pageNum) {
      var self = this;

      self.currentPage = _pageNum

      self.setQueryString();

      self.getData();
    },
    onReset: function(_ev) {
      _ev.preventDefault();

      var self = this;

      self.form = {
        end_at: Vue.moment(),
        interval: [Vue.moment().subtract(30, "days"), Vue.moment()],
        proposal_status_id: "",
        administrator_id: "",
        salesman_id: "",
        group_id: "",
        quota: "",
        physical_proposal: "",
        client_name: ""
      };

      self.currentPage = 1;

      self.getData();
    },
    onSubmit(_ev=null) {
      if(isNaN(_ev))
        _ev.preventDefault();

      var self = this;

      self.setQueryString();

      self.getData();
    },
    remove: function(_item) {
      var self = this;

      self.$dialog
        .confirm("Deseja realmente remover a proposta " + _item + "?")
        .then(function() {
          self.$root.$emit("onLoading");

          const response = self.$store.dispatch("proposals/rem", { id: _item });

          response.then(function() {
            self.$root.$emit("onLoading");
            self.$notify.success("Proposta excluída com sucesso!");
            self.getData();
          });

          response.catch(function() {
            self.$root.$emit("onLoading");
            self.$notify.danger("Não foi possível excluir a proposta!");
          });
        });
    },
    setQueryString() {
      var self = this;

      self.$router.push({
          name: "proposals.index",
          query: {
            limit: self.limit ? self.limit : 5,
            currentPage: self.currentPage,
            salesman_id: self.form.salesman_id,
            proposal_status_id: self.form.proposal_status_id,
            administrator_id: self.form.administrator_id,
            group_id: self.form.group_id,
            quota: self.form.quota,
            physical_proposal: self.form.physical_proposal,
            client_name: self.form.client_name,
            interval: [
              Vue.moment(self.form.interval[0]).format('YYYY-MM-DD'),
              Vue.moment(self.form.interval[1]).format('YYYY-MM-DD')
            ],
            date_filter: self.form.date_filter,
          }
      })
    }
  },
  destroyed () {
    var self = this;
    self.$root.$off("changeBranch", self.getData());
  }
};
</script>
<style scoped>
.card-icon {
  cursor: pointer;
}
</style>